export default __webpack_public_path__ + "static/icon-1d2819f5b3a9b157d2f41fc99cb76316.png";